/* eslint-disable id-length */
import React, { memo, useContext, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { isEmpty } from 'lodash';

import BatchContext from '@components/batch/batch-upload-edit/batch-context';
import {
  FILTER_ALL,
  FILTER_ERRORS,
  FILTER_SKIPPED
} from '@components/batch/batch-upload-edit/constants';
import DrawerRowItemCard from '@components/batch/batch-upload-edit/drawer-row-item-card';

import DnsOutlinedIcon from '@material-ui/icons/DnsOutlined';

import { getBatchRows } from '@selectors/batch-edit-selector';

import './drawer-row-list.scss';

const DrawerRowList = () => {
  const { fileId, filter } = useContext(BatchContext);
  const batchRows = useSelector(state => getBatchRows(state, fileId));
  const rows = useMemo(() => {
    const unsortedRows = Object.values(batchRows);
    return unsortedRows.sort((a, b) => {
      const firstRowNumA = parseInt(a.display_row_nums.split('-')[0], 10);
      const firstRowNumB = parseInt(b.display_row_nums.split('-')[0], 10);
      return firstRowNumA - firstRowNumB;
    });
  }, [batchRows]);

  const filteredRows = useMemo(() => {
    if (filter === FILTER_ALL) {
      return rows;
    }
    if (filter === FILTER_ERRORS) {
      return rows?.filter(row => !isEmpty(row?.errors));
    }
    if (filter === FILTER_SKIPPED) {
      return rows?.filter(row => row.skipped === true);
    }
    return [];
  }, [filter, rows]);

  if (filteredRows?.length === 0) {
    return (
      <div styleName="batch-upload-edit-drawer-row-list-container">
        <div styleName="row-list-empty">
          <div styleName="content">
            <div styleName="icon">
              <DnsOutlinedIcon htmlColor="#C2CBF5" style={{ fontSize: '6rem' }} />
            </div>
            <div styleName="message">No entities found</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div styleName="batch-upload-edit-drawer-row-list-container">
      <ul styleName="row-list-body">
        {filteredRows?.map((row, index) => <DrawerRowItemCard key={row.id} index={index + 1} row={row} />)}
      </ul>
    </div>
  );
};

export default memo(DrawerRowList);
